import React from 'react';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import {
  ConfigSection,
  FormRow,
  ActionButtons,
  StyledDivider,
  MonthFormControl
} from '#component/reports/styles';
import ProjectSelector from './project-selector';

const ReportConfig = ({
  selectedProject,
  onProjectChange,
  yearOptions,
  monthOptions,
  selectedYear,
  selectedMonth,
  onYearChange,
  onMonthChange,
  onGenerateReport,
  canGenerate,
  loading
}) => (
  <ConfigSection elevation={1}>
    <Typography variant="h6" gutterBottom>
      Report Configuration
    </Typography>
    <StyledDivider />

    <FormRow>
      <ProjectSelector value={selectedProject} onChange={onProjectChange} />

      <MonthFormControl>
        <InputLabel>Year *</InputLabel>
        <Select
          value={selectedYear}
          onChange={onYearChange}
          label="Year *"
        >
          {yearOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </MonthFormControl>

      <MonthFormControl>
        <InputLabel>Month *</InputLabel>
        <Select
          value={selectedMonth}
          onChange={onMonthChange}
          label="Month *"
        >
          {monthOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </MonthFormControl>
    </FormRow>

    <ActionButtons>
      <Button
        variant="contained"
        color="primary"
        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <PlayArrowIcon />}
        onClick={onGenerateReport}
        disabled={!canGenerate || loading}
      >
        {loading ? 'Generating...' : 'Generate Report'}
      </Button>
    </ActionButtons>
  </ConfigSection>
);

export default ReportConfig;
